import GenSettingTable from "../../../views/GenSetting";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const GenSettingRoutes = [
  {
    menuName: MenuNames.CONFIG,
    path: "/relaxation-configuration/gen-setting",
    component: GenSettingTable,
    exact: true,
  },
  {
    menuName: MenuNames.CONFIG,
    path: "/relaxation-configuration/city-property/:id(\\d+)",
    component: GenSettingTable,
    exact: true,
  },
];

export default GenSettingRoutes;
